import {
    GET_PENDING_POD_REGION_STATE_REPORT_ERROR,
    GET_PENDING_POD_REGION_STATE_REPORT_REQUEST,
    GET_PENDING_POD_REGION_STATE_REPORT_SUCCESS,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_PENDING_POD_REGION_STATE_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_PENDING_POD_REGION_STATE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_PENDING_POD_REGION_STATE_REPORT_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}